import React from 'react';
import PropTypes from 'prop-types';
import RecorderOptions from './RecorderOptions';
import { assetUrl } from '../../config/asset-config';

/**
 * Component for recording video using webcam or file upload
 */
const Recorder = ({
    isWebcamOpen,
    streamType,
    selectedResolution,
    videoRef,
    canvasRef,
    fileInputRef,
    status,
    recordingTime,
    recordingLimit,
    audioDevices,
    cameraDevices,
    backgrounds,
    portalHasVirtualBackgrounds,
    isBgEnabled,
    handleBlur = () => { },
    handleImage = () => { },
    setStream = () => { },
    setResolution = () => { },
    setInternalResolution = () => { },
    handleFileUpload = () => { },
    setBackgrounds = () => { },
    resetRecorder = () => { },
}) => (
    <>
        {/* Render recorder container if webcam is open and status is valid */}
        {
            isWebcamOpen && ['activatingCamera', 'beginRecording', 'recording', 'recordingCountdown', 'cameraDenied', 'idle', 'waiting'].includes(status) && (
                <div className="tv-recorder__record-container">
                    {
                        ['activatingCamera', 'cameraDenied'].includes(status) && (
                            <div className="recorder-overlay">
                                <img className="block max-width-150px md-max-width-200px margin-center" src={assetUrl('assets/img/recording/envelope_wand.svg')} alt="" />
                                <h2>Enable your webcam and microphone to start recording your ThankView!</h2>
                            </div>
                        )
                    }
                    {/* Render recorder options */}
                    <RecorderOptions status={status} streamType={streamType} selectedResolution={selectedResolution} setResolution={setResolution} setInternalResolution={setInternalResolution} portalHasVirtualBackgrounds={portalHasVirtualBackgrounds} isBgEnabled={isBgEnabled} recordingTime={recordingTime} recordingLimit={recordingLimit} setStream={setStream} audioDevices={audioDevices} cameraDevices={cameraDevices} backgrounds={backgrounds} handleBlur={handleBlur} handleImage={handleImage} setBackgrounds={setBackgrounds} resetRecorder={resetRecorder}/>

                    {/* Render webcam video container */}
                    <div id="recorder-webcam" className="bg-black">
                        <video ref={videoRef} autoPlay playsInline muted style={{
                            transform: streamType === 'screen' ? 'none' : 'transform: scaleX(-1)',
                        }}/>
                        <canvas ref={canvasRef}></canvas>
                    </div>
                </div>
            )
        }
        {/* Add the file input element for video selection */}
        <input type="file" name="file" accept="video/mpg,video/mpeg,video/mp4,video/x-m4v,video/avi,video/x-matroska,video/quicktime,video/*;capture=camcorder" aria-label="Upload a Video" style={{ display: 'none' }} ref={fileInputRef} onChange={handleFileUpload} />
    </>

);

Recorder.propTypes = {
    isWebcamOpen: PropTypes.bool,
    streamType: PropTypes.string,
    selectedResolution: PropTypes.object,
    videoRef: PropTypes.object,
    canvasRef: PropTypes.object,
    fileInputRef: PropTypes.object,
    status: PropTypes.string,
    recordingTime: PropTypes.string,
    recordingLimit: PropTypes.string,
    audioDevices: PropTypes.array,
    cameraDevices: PropTypes.array,
    backgrounds: PropTypes.array,
    portalHasVirtualBackgrounds: PropTypes.bool,
    isBgEnabled: PropTypes.bool,
    handleBlur: PropTypes.func,
    handleImage: PropTypes.func,
    setStream: PropTypes.func,
    setResolution: PropTypes.func,
    setInternalResolution: PropTypes.func,
    handleFileUpload: PropTypes.func,
    setBackgrounds: PropTypes.func,
    resetRecorder: PropTypes.func,
};

export default Recorder;
